export default "d494428f62a81a43.svg"